module.exports = __webpack_public_path__ + "static/media/infoJumbo3.cd90789c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/steidle/images/infoJumbo3.jpg
// module id = 562
// module chunks = 0